nationalCode.$inject = [];
function nationalCode () {
    return {
        require: 'ngModel',
        scope: {},
        link: function (scope, elem, attrs, ngModelCtrl) {
            ngModelCtrl.$validators.nationalCode =
           function (modelValue) {
                function checkCodeMeli(code) {
                    var L = code.length;
                    switch (code) {
                    case "1111111111":
                        return false;
                    case "2222222222":
                        return false
                    case "3333333333":
                        return false;
                    case "4444444444":
                        return false;
                    case "5555555555":
                        return false;
                    case "6666666666":
                        return false;
                    case "7777777777":
                        return false;
                    case "8888888888":
                        return false;
                    case "9999999999":
                        return false;
                    case "0000000000":
                        return false;
                    }
                    if (L < 8 || parseInt(code, 10) == 0) return false;
                    code = ('0000' + code).substr(L + 4 - 10);
                    if (parseInt(code.substr(3, 6), 10) == 0) return false;
                    var c = parseInt(code.substr(9, 1), 10);
                    var s = 0;
                    for (var i = 0; i < 9; i++)
                        s += parseInt(code.substr(i, 1), 10) * (10 - i);
                    s = s % 11;
                    return (s < 2 && c == s) || (s >= 2 && c == (11 - s));
                }

                return checkCodeMeli(modelValue || "")
            
            }
        }
    }
}


module.exports = ngModule => {
    ngModule.directive('nationalCode', nationalCode);
};